import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { ReactElement, useEffect, useState } from "react";
import { actions as reportsActions } from "../../../../actions/reportsActions";
import { useDispatch } from "react-redux";
import type { Dispatch } from "redux";
import * as types from "../../../../constants/actionTypes";
import Notification from "../../../Common/Notification";
import { useHistory } from "react-router-dom";
import Moment from "moment";
import { DATE_FORMAT } from "../../../../constants/constants";

import { ScheduledReportTable } from "./styles";

interface ScheduledReportsProps {
    all: boolean;
}

interface ScheduledReport {
    id: number;
    ssrsSubscriptionId: string;
    ownerId: number;
    ownerName: string;
    scheduleName: string;
    reportName: string;
    lastRun: Date;
    lastRunResult: string;
}

const ScheduledReports = ({ all }: ScheduledReportsProps): ReactElement => {
    const history = useHistory();

    const [scheduledReports, setscheduledReports] =
        useState<ScheduledReport[]>();

    const [isLoading, setIsLoading] = useState<boolean>(true);

    const dispatch: Dispatch = useDispatch();

    const loadScheduledReports = async () =>
        dispatch(reportsActions.loadScheduledReports(all));

    const deleteScheduledReports = async (id: number) =>
        dispatch(reportsActions.deleteScheduledReport(id));

    const formatReports = async () => {
        try {
            const result = await loadScheduledReports();
            const payload = result.payload;
            if (result.type === types.LOAD_SCHEDULED_REPORTS_SUCCESS) {
                setscheduledReports(payload.scheduledReports);
                setIsLoading(false);
            } else if (result.type === types.LOAD_SCHEDULED_REPORTS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    };

    const actionTemplate = (rowData: ScheduledReport) => {
        return (
            <>
                <span className="text-center">
                    <i
                        className="fa-regular fa-pen-to-square fa-lg mx-2"
                        onClick={() => editReportClick(rowData)}
                    ></i>
                </span>
                <span className="text-danger text-center">
                    <i
                        className="fa-regular fa-trash-can fa-lg mx-2"
                        onClick={() => deleteReportClick(rowData.id)}
                    ></i>
                </span>
            </>
        );
    };

    const dateFormat = (rowData: ScheduledReport) => {
        return Moment.utc(rowData.lastRun).format(DATE_FORMAT);
    };

    const editReportClick = (report: ScheduledReport) => {
        history.push(`/schedule-report/edit/${report.id}`);
    };

    const deleteReportClick = async (id: number) => {
        try {
            const result = await deleteScheduledReports(id);
            const payload = result.payload;
            if (result.type === types.DELETE_SCHEDULED_REPORT_SUCCESS) {
                Notification(
                    "success",
                    "Success",
                    "Scheduled Report was deleted!"
                );
            } else if (result.type === types.DELETE_SCHEDULED_REPORT_FAILURE) {
                Notification("error", "An Error Occurred", payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    };

    useEffect(() => {
        formatReports();
    }, []);

    return (
        <ScheduledReportTable>
            <DataTable
                filterDisplay="row"
                loading={isLoading}
                emptyMessage="No scheduled reports found."
                value={scheduledReports}
                className="p-datatable-sm p-datatable-striped"
            >
                <Column
                    key="ownerName"
                    field="ownerName"
                    header="Owner"
                    sortable={false}
                    className="data-column"
                    headerClassName="data-header"
                ></Column>
                <Column
                    key="scheduleName"
                    field="scheduleName"
                    header="Schedule Name"
                    sortable={false}
                    className="data-column"
                    headerClassName="data-header"
                ></Column>
                <Column
                    key="reportName"
                    field="reportName"
                    header="Report Name"
                    sortable={false}
                    className="data-column"
                    headerClassName="data-header"
                ></Column>
                <Column
                    key="lastRun"
                    field="lastRun"
                    header="Last Run"
                    sortable={false}
                    body={dateFormat}
                    className="data-column"
                    headerClassName="data-header"
                ></Column>
                <Column
                    key="lastRunResult"
                    field="lastRunResult"
                    header="Last Run Result"
                    sortable={false}
                    className="data-column"
                    headerClassName="data-header"
                ></Column>
                <Column
                    key="actions"
                    field="actions"
                    header=""
                    body={actionTemplate}
                    sortable={false}
                    className="data-column"
                    headerClassName="data-header"
                ></Column>
            </DataTable>
        </ScheduledReportTable>
    );
};

export default ScheduledReports;
